<template>
  <div class="slider fullSize">
    <ul class="slides fullSize">
      <li>
        <img src="ui/img/slider/i-slider7.jpg" />
        <!-- random image -->
        <!-- <div class="caption right-align" style="opacity: 1;transform: translateX(0px) translateY(294px);"> -->
        <div class="caption right-align">
          <button
            class="waves-effect btn btn__signup space--left"
            @click="login('vendor')"
          >
            BECOME A MERCHANT
          </button>
        </div>
      </li>
      <li>
        <img src="ui/img/slider/i-slider1.jpg" />
        <!-- random image -->
        <div class="caption center-align"></div>
      </li>
      <li>
        <img src="ui/img/slider/i-slider2.jpg" />
        <!-- random image -->
        <div class="caption center-align"></div>
      </li>
      <li>
        <img src="ui/img/slider/i-slider3.jpg" />
        <!-- random image -->
        <div class="caption center-align"></div>
      </li>
      <li>
        <img src="ui/img/slider/i-slider4.jpg" />
        <!-- random image -->
        <div class="caption center-align"></div>
      </li>
      <li>
        <img src="ui/img/slider/i-slider5.jpg" />
        <!-- random image -->
        <div class="caption center-align"></div>
      </li>
      <li>
        <img src="ui/img/slider/i-slider6.jpg" />
        <!-- random image -->
        <div class="caption center-align"></div>
      </li>
      <li>
        <img src="ui/img/slider/i-slider8.jpg" />
        <!-- random image -->
        <div class="caption center-align"></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AdsSlider',
  data() {
    return {}
  },
  methods: {
    login(option) {
      document.getElementById('myNav').style.width = '100%'
      this.$emit('modal-option', option)
    }
  }
}
</script>

<style></style>
